export enum StyleStateEnum {
    DEFAULT = 'DEFAULT',
    CUSTOM = 'CUSTOM'
}
